import React from 'react'
import {Form, Icon, Input, Checkbox, Select, Col, Button, DatePicker} from 'antd';

const { Option } = Select;

// window.scrollTo(0, 0);

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    const oneOfReasons = props.form.getFieldValue('dc_reason_deferred_1') || props.form.getFieldValue('dc_reason_deferred_2') || props.form.getFieldValue('dc_reason_deferred_3') || props.form.getFieldValue('dc_reason_deferred_4') || props.form.getFieldValue('dc_reason_deferred_5');

    return (
      <div className="form-group">
        <h4>Consent Process - Investigator</h4>

        <div className="form-group-details">
          <h5>Site ID: <b>{props.siteID}</b></h5>
          <h5>User ID: <b>{props.userID}</b></h5>
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>

        {props.has_randomization_platform_step_3_deferred ?
          <div dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_deferred_content}}/> :

          <div>
            <h4 align="center">INFORMATION AND CONSENT FORM: {props.has_randomization_platform_step_3_patient}</h4>
            <h4 align="center">Deferred Consent for Research Participation</h4>
            <h4>Title of Project: Alteplase Compared to Tenecteplase in Quality Improvement & Clinical Research Alberta
              Stroke Program (ACT): A Pragmatic, Registry-based Randomized Controlled Trial (AcT RRCT)</h4>
            <p><strong>Principal Investigator:&nbsp;  Dr. Brian Buck</strong></p>
            <p>Phone Number: 780-248-1927</p>
            <br/>

            <p><strong>Co-Investigators: Dr. Ashfaq Shuaib, Dr. Glen Jickling, Dr. Tom Jeerakathil, Dr. Mahesh Kate, Dr.
              Muzaffar Siddiqui, Dr. Sachin Mishra, Dr, Khurshid Khan, Dr. Sibi Thirunavukkarasu, Dr. Asif Butt, Dr. Ali
              Nomani</strong></p>
            <p>The patient named below is being enrolled in this research study by deferred consent.</p>

            <p>When a previously incapacitated participant regains capacity, or when a substitute decision maker is
              found, consent shall be sought promptly for continuation in the study, and for subsequent examinations or
              tests related to the research study. Seeking consent prior to study participation is always
              preferable.</p>
            <p>If no substitute decision maker/family member is available on site or they refuse to give consent, any
              data or samples collected for study purposes will be destroyed.</p>
          </div>
        }

        <p><strong>Date/time assessed for enrolment: {props.date || props.consentDate}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        <Form.Item>
          <label>
            <div className='form-label'>Patient's name</div>
            {props.form.getFieldDecorator('dc_patient_name', {
              initialValue: props.dc_patient_name,
              rules: [{
                required: true,
                message: 'Please enter the Patient\'s name'
              }],
            })(
              <Input
                prefix={<Icon type="user" style={{color: '#eee'}}/>}
                placeholder="Patient's name"
              />
            )}
          </label>
        </Form.Item>

        {/*<Form.Item>
        <label>Date and time</label>
        <div style={{ display: 'flex', alignItems: 'center', maxWidth: '400px' }}>
          {props.form.getFieldDecorator('dc_enrolment_datetime', { rules: [{ required: true, message: 'Required' }] })(
            <DatePicker
              placeholder="yyyy-mm-dd"
              format='YYYY/MM/DD HH:mm'
              showTime={{ format: 'HH:mm' }}
            />,
          )}

          &nbsp;{props.userShortTimezone || 'UTC'}
        </div>
      </Form.Item>*/}

        {props.consentMethodType === 'Email' && <Form.Item>
          {props.form.getFieldDecorator('pcf_participant_email', {
            initialValue: props.pcf_participant_email,
            rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
          })(
            <Input placeholder="Participant Email"/>
          )}
        </Form.Item>}

        {props.consentMethodType === 'Email' && <Form.Item>
          <div className='form-label'>Person obtaining consent</div>
          {props.form.getFieldDecorator('wcf_person_obtaining_consent_name', {
            initialValue: props.wcf_person_obtaining_consent_name,
            rules: [{
              required: true,
              message: 'required'
            }],
          })(
            <Input
              prefix={<Icon type="user" style={{color: '#eee'}}/>}
              placeholder="Person obtaining consent name"
              autoFocus
            />
          )}
        </Form.Item>}

        {/*<Form.Item>
        <label>
          <div className='form-label'>Investigator's name</div>
          {props.form.getFieldDecorator('investigatorFullName', {
            initialValue: props.investigatorFullName,
            rules: [{
                required: true,
                message: 'Please enter the Investigator\'s name'
            }],
          })(
            <Input
              prefix={<Icon type="user" style={{color: '#333'}}/>}
              placeholder="Investigator's name"
            />
          )}
        </label>
      </Form.Item>*/}

        <p><b>Reason(s) deferred consent process is used (check all that apply):</b></p>
        <Form.Item>
          <label>
            {props.form.getFieldDecorator('dc_reason_deferred_1', {
              initialValue: false,
              valuePropName: 'checked'
            })(<Checkbox>The patient is unconscious or lacks capacity to understand the risks, methods and purposes of
              the research study.</Checkbox>)}
          </label>
        </Form.Item>

        <Form.Item>
          <label>
            {props.form.getFieldDecorator('dc_reason_deferred_2', {
              initialValue: false,
              valuePropName: 'checked'
            })(<Checkbox>No next of kin/substitute decision maker is available to provide consent, or attempts to
              contact them have been unsuccessful despite diligent and documented efforts.</Checkbox>)}
          </label>
        </Form.Item>

        <Form.Item>
          <label>
            {props.form.getFieldDecorator('dc_reason_deferred_3', {
              initialValue: false,
              valuePropName: 'checked'
            })(<Checkbox>A substitute decision maker has been contacted by telephone, and the purpose, methods and risks
              of participation in this study have been explained to the third party. While the substitute decision maker
              has given verbal consent for participation, written consent must be still be obtained.</Checkbox>)}
          </label>
        </Form.Item>

        {props.form.getFieldValue('dc_reason_deferred_3') && <div>
          <Form.Item>
            <label>
              <div className='form-label'>Decision maker name and relationship</div>
              {props.form.getFieldDecorator('dc_reason_deferred_3_name_relationship', {
                rules: [{
                  required: true,
                  message: 'required'
                }],
              })(<Input/>)}
            </label>
          </Form.Item>
        </div>}

        <Form.Item>
          <label>
            {props.form.getFieldDecorator('dc_reason_deferred_4', {
              initialValue: false,
              valuePropName: 'checked'
            })(<Checkbox>No relevant prior directive by the patient is known to exist.</Checkbox>)}
          </label>
        </Form.Item>

        <Form.Item>
          <label>
            {props.form.getFieldDecorator('dc_reason_deferred_5', {
              initialValue: false,
              valuePropName: 'checked',
              rules: [{
                required: !oneOfReasons,
                transform: value => (value || undefined),
                type: 'boolean',
                message: 'One of reasons must be selected'
              }],
            })(<Checkbox>Other</Checkbox>)}
          </label>
        </Form.Item>

        {props.form.getFieldValue('dc_reason_deferred_5') && <Form.Item>
          <label>
            <div className='form-label'>Other reasons</div>
            {props.form.getFieldDecorator('dc_reason_deferred_5_other', {
              initialValue: props.dc_reason_deferred_5_other,
              rules: [{
                required: true,
                message: 'required'
              }],
            })(
              <Input.TextArea
                placeholder="Other reasons"
              />
            )}
          </label>
        </Form.Item>}


        {/*<Col span={12}>
          <Form.Item>
            <label>
              <div className='form-label'>Decision maker name</div>
              {props.form.getFieldDecorator('decisionMakerName', {
                initialValue: props.decisionMakerName,
                rules: [{
                  required: true,
                  message: 'required'
                }],
              })(
                <Input />
              )}
            </label>
          </Form.Item>
        </Col>*/}


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLethbridge/Step3aInvestigator.js